module.exports = __webpack_public_path__ + "static/media/clipboard.9238e2ee.svg";